import { render, staticRenderFns } from "./CrearContraseniaProspecto.vue?vue&type=template&id=2a16dad6&scoped=true&"
import script from "./CrearContraseniaProspecto.vue?vue&type=script&lang=js&"
export * from "./CrearContraseniaProspecto.vue?vue&type=script&lang=js&"
import style0 from "./CrearContraseniaProspecto.vue?vue&type=style&index=0&id=2a16dad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16dad6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VContainer,VImg,VRow,VTextField})
